import { SelectType } from '@ui/src';
import { useAppSelector } from '@store';
import GeneralUserInfoRow from './general-user-info-row';
import { GeneralInfoUserProductsTypes } from '../types';

import cn from './overview-content.module.css';

const GeneralUserInfoProducts = ({
  baseUserInformation,
  control,
  edit,
  errors,
}: GeneralInfoUserProductsTypes) => {
  const { productsIndividual } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  return (
    <div
      className={cn.generalUserInfoBlock}
      style={{ zIndex: 9, position: 'relative' }}
    >
      {!edit && (
        <div className={cn.productsRow}>
          <div className={cn.productsRowTitle}>Products</div>
          <div className={cn.productsRowContent}>
            {productsIndividual
              ?.filter((item) => {
                let result;

                if (
                  baseUserInformation?.products?.find(
                    (product) => product === item.value,
                  )
                ) {
                  result = item;
                }

                return result;
              })
              .map((item) => (
                <div className={cn.productRowItem} key={item.value}>
                  {item.name}
                </div>
              ))}
          </div>
        </div>
      )}
      {edit && (
        <GeneralUserInfoRow
          title="Products"
          control={control}
          type="select"
          disabled={!edit}
          name="productIds"
          selectType={SelectType.MULTIPLE}
          defaultValue={productsIndividual
            ?.filter((item) => {
              let result;

              if (
                baseUserInformation?.products?.find(
                  (product) => product === item.value,
                )
              ) {
                result = item;
              }

              return result;
            })
            .map((item) => item.name)
            .join(', ')}
          list={productsIndividual}
          zIndex={15}
          error={errors?.productIds?.message}
        />
      )}
    </div>
  );
};

export default GeneralUserInfoProducts;
